import React from 'react';

const Security: React.FC = () => {
  return (
    <div className="security">
      <h1>Sicherheit</h1>
      <p>Sicherheitseinstellungen und Passwortverwaltung.</p>
    </div>
  );
};

export default Security;
